<template>
    <div>
        <div v-show="panel_required">
            <tile-question-layout :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title"
                                  :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list"
                                  :thumb_url="thumbURL"
                                  :component_id="component_id"
                                  :fabricator="fabricator"
            ></tile-question-layout>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionGlassBackingDesign from "../DesignerQuestionGlassBackingDesign.vue";

    export default {
        mixins: [
            DesignerQuestionGlassBackingDesign
        ],
    }
</script>
